import { AppDispatch } from "@src/store";
import { getDefaultHiddenEndTime } from "@src/store/helpers";
import { updateDashboardFilter } from "@src/store/slices/dashboardFilters";
import { Experience } from "@src/store/slices/experiences/types";
import { setDialog } from "@src/store/slices/global";

export const isRolloutEnabled = (
  experience: Experience,
  hasPersonalizationAccess: boolean
) => {
  return (
    hasPersonalizationAccess &&
    experience.status !== "pending" &&
    !experience.testTypes.hasTestShipping &&
    (!experience.testTypes.hasTestPricing ||
      (experience.status !== "started" &&
        experience.status !== "ended" &&
        experience.testTypes.hasTestPricing))
  );
};

export const renderRolloutButton = (
  tabClicked: string,
  analyticsDataNotAvailable: boolean,
  isDataLoading: number,
  experience: Experience,
  hasPersonalizationAccess: boolean,
  location: "Menu" | "ActionButtons"
) => {
  const rolloutEnabled = isRolloutEnabled(experience, hasPersonalizationAccess);

  if (location === "ActionButtons" && tabClicked === "analytics") {
    if (analyticsDataNotAvailable === undefined || isDataLoading !== 0) {
      return false;
    }
    return !analyticsDataNotAvailable && rolloutEnabled;
  } else if (location === "Menu" && tabClicked !== "analytics") {
    return rolloutEnabled;
  }

  return false;
};

export const onRolloutClick = (
  experience,
  storeCurrencyConfig,
  dispatch: AppDispatch
) => {
  dispatch(
    updateDashboardFilter({
      key: "hiddenEndTime",
      value: getDefaultHiddenEndTime(experience),
    })
  );

  if (experience.testTypes.hasTestPricing) {
    onPriceTestAction(
      experience,
      "end",
      storeCurrencyConfig?.value?.code ?? "USD",
      dispatch
    );
  } else {
    dispatch(
      setDialog({
        open: true,
        dialog: "rollouts",
      })
    );
  }
};

export const onPriceTestAction = (
  experience: Experience,
  action: "start" | "pause" | "end",
  storeCurrencyConfigCode: string,
  dispatch: AppDispatch
) => {
  if (
    experience.currency?.code &&
    storeCurrencyConfigCode !== experience.currency?.code
  ) {
    if (action === "start") {
      dispatch(setDialog({ dialog: "marketPriceUpdaterStart", open: true }));
    } else {
      dispatch(
        setDialog({
          dialog: "marketPriceUpdater",
          open: true,
          props: { action: action },
        })
      );
    }
  } else {
    if (action === "start") {
      dispatch(
        setDialog({
          dialog: "priceUpdaterStart",
          open: true,
          props: { action: action },
        })
      );
    } else {
      dispatch(
        setDialog({
          dialog: "priceUpdater",
          open: true,
          props: { action: action },
        })
      );
    }
  }
};
